import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../api";
import { AttendanceLocal } from "../../../../@types/attendance-local";
import { AxiosError } from "axios";

export type AttendanceLocalExpedientCreateData = Pick<
    AttendanceLocal['horario_unidade'],
    | "dia_semana"
    | "intervalo_ativo"
    | "hora_inicio_manha"
    | "hora_inicio_tarde"
    | "hora_fim_manha"
    | "hora_fim_tarde"
> & {
    unidade: AttendanceLocal['slug_unidade'];
}

export function useAttendanceLocalExpedientCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "expedient", "create"],
        mutationFn: async (data: AttendanceLocalExpedientCreateData) => {
            const response = await apisiseci.post<AttendanceLocalExpedientCreateData>(
                '/cms/horario_unidade/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async (data) => {
            toast.success("Horário de funcionamento atualizado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "details", data.unidade],
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
